<ng-container
  *ngIf="
    !(transactions$ | async)?.isFetching && (transactions$ | async)?.result
  "
>
  <my-bill-nothing-to-pay-card
    [hasInstalmentPlan]="hasInstalmentPlan"
    *ngIf="showNothingToPayCard"
  ></my-bill-nothing-to-pay-card>

  <my-bill-balance-card
    [billingAccount]="billingAccount"
    [hasInstalmentPlan]="hasInstalmentPlan"
    [billingTransactions]="(transactions$ | async)?.result"
    *ngIf="!showNothingToPayCard"
  ></my-bill-balance-card>

  <my-bill-instalment-plan-card
    *ngIf="hasInstalmentPlan"
    [instalmentPlanInformation]="instalmentPlanInformation"
    [transactions]="(transactions$ | async)?.result"
  ></my-bill-instalment-plan-card>

  <div class="rs-panel-big rs-bg-c2 clearfix">
    <p class="rs-tit4">
      {{ openBillsText }}
    </p>
    <p *ngIf="noOpenBills; else showOpenBills">
      {{ noOpenBillsText }}
    </p>
    <ng-template #showOpenBills>
      <my-bill-transaction-card
        *ngFor="
          let billingDocument of (transactions$ | async).result.openTransactions
            .billingDocuments;
          let indexOfElement = index
        "
        [balance]="billingDocument.balance"
        [billingAccount]="billingAccount"
        [billingDocument]="billingDocument"
        [openTransactionToPayIndex]="indexOfElement"
      >
      </my-bill-transaction-card>
    </ng-template>
    <div class="rs-accordion-single-container" *ngIf="hasClosedBills">
      <button
        class="rs-accordion-single"
        data-expandable=""
        [attr.aria-expanded]="showMoreButtonClicked"
        aria-controls="ac-showMoreContent0"
        id="ac-showMoreBtn0"
        (click)="onShowMoreBillsButtonClicked()"
        data-tms-event="button-click"
        data-tms-button-zone="mybill.overview"
        data-tms-button-name="show more bills"
      >
        {{ showPaidBillsText }}
        <i class="rs-accordion-single-icon" aria-hidden="true"></i>
      </button>
      <div
        class="rs-accordion-single-content"
        role="region"
        id="ac-showMoreContent0"
        aria-labelledby="ac-showMoreBtn0"
        aria-hidden="true"
      >
        <p class="rs-tit4">
          {{ paidBillsText }}
        </p>

        <my-bill-transaction-card
          *ngFor="
            let billingDocument of (transactions$ | async).result
              .recentClosedTransactions;
            let closedTransactionsIndex = index
          "
          [balance]="billingDocument.balance"
          [billingAccount]="billingAccount"
          [billingDocument]="billingDocument"
          [openTransactionToPayIndex]="closedTransactionsIndex"
        >
        </my-bill-transaction-card>
      </div>
    </div>
  </div>
</ng-container>
